"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AndroidCapabilities = (function () {
    function AndroidCapabilities() {
    }
    AndroidCapabilities.prototype.hasLifecycleSuspension = function () {
        return true;
    };
    AndroidCapabilities.prototype.hasNativeParentalPin = function () {
        return false;
    };
    AndroidCapabilities.prototype.hasExternalAppsDisplay = function () {
        return false;
    };
    AndroidCapabilities.prototype.hasVolumeControl = function () {
        return false;
    };
    AndroidCapabilities.prototype.hasExternalAppsLaunch = function () {
        return false;
    };
    return AndroidCapabilities;
}());
exports.AndroidCapabilities = AndroidCapabilities;
